import { checkLinkSecurity, type RequestResponseTypes } from '@/core/api/serasaApi'

import { LinkSecurityTypeParser, MODALS_CONTENT } from '../Modal/ModalContent/constants'
import type { ModalContentProps } from '../Modal/types'

export const getModalContent = async (link: string): Promise<ModalContentProps> => {
  try {
    const response: RequestResponseTypes = await checkLinkSecurity({ link })
    const linkSecurityType = LinkSecurityTypeParser[response]
    return MODALS_CONTENT[linkSecurityType]
  } catch (err) {
    return MODALS_CONTENT.requestFailed
  }
}
